export default ({ $auth, redirect, $RouteEnum, from }) => {
  if ($auth.isLoggedIn) {
    if (from.query.to) {
      redirect(302, from.query.to, { ...from.query, to: undefined });
      return;
    }
    redirect({ name: $RouteEnum.DASHBOARD });
  }
};
